// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3UPtq","title":"Info_title__1lzWX","links":"Info_links__2o72o","link":"Info_link__2_uxj","logo":"Info_logo__1c5Np"};